import React from 'react';
import PropTypes from 'prop-types';

import { ANNUAL_POWER_STEPS, DEFAULT_STEPS } from './constants';
import styles from './registrationStepIndicator.scss';

const RegistrationStepIndicator = ({ showAnnualPowerStep, isUpgradeStep, isCheckoutStep, hideSteps, hideTitle }) => {
    const steps = showAnnualPowerStep ? ANNUAL_POWER_STEPS : DEFAULT_STEPS;

    const currentStep = (() => {
        if (isUpgradeStep) {
            return steps[0].number;
        }
        if (isCheckoutStep) {
            return steps[steps.length - 1].number;
        }
        return showAnnualPowerStep ? steps[1].number : steps[0].number;
    })();

    return (
        <div className={`${styles.registrationStepIndicator} ${hideSteps ? styles.titleOnly : ''}`} data-test="registration-step-indicator">
            {isUpgradeStep && !hideTitle && (
                <div className={styles.title} data-test="step-indicator-title">This event requires an annual Power membership</div>
            )}
            {!hideSteps && (
                <div className={styles.steps}>
                    {steps.map((step) => {
                        const isActive = step.number === currentStep;
                        return (
                            <div
                                key={step.number}
                                className={`${styles.step} ${isActive ? styles.active : ''}`}
                                data-test={`step-${step.number}`}
                                data-active={isActive}
                            >
                                <div className={styles.circle}>{step.number}</div>
                                <span className={styles.label}>{step.label}</span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

RegistrationStepIndicator.propTypes = {
    showAnnualPowerStep: PropTypes.bool,
    isUpgradeStep: PropTypes.bool,
    isCheckoutStep: PropTypes.bool,
    hideSteps: PropTypes.bool,
    hideTitle: PropTypes.bool,
};

RegistrationStepIndicator.defaultProps = {
    showAnnualPowerStep: false,
    isUpgradeStep: false,
    isCheckoutStep: false,
    hideSteps: false,
    hideTitle: false,
};

export default RegistrationStepIndicator;
